import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Form from 'components/Form/Form';
import { clearRequest } from 'store/ApiClient/actions';

interface IClearableFormProps {
  onSubmit?: () => void;
  onChange?: () => void;
  encType?: string;
  formId?: string;
  dataCy?: string;
}

const ClearableForm: React.FC<IClearableFormProps> = ({ onSubmit, onChange, formId, dataCy, ...props }) => {
  const dispatch = useDispatch();
  const onNewForm = useCallback(() => {
    if (formId) dispatch(clearRequest(formId.replace('_REQUEST', '')));
  }, [dispatch, formId]);

  return (
    <Form onSubmit={onSubmit} onChange={onChange} formId={formId} onNewForm={onNewForm} data-cy={dataCy}>
      {props.children}
    </Form>
  );
};

export default ClearableForm;
